<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<div class="component-container">
  <app-event-template-list
    [viewList]="viewList"
    [directoryList]="directoryList"
    [scenarioTemplateList]="scenarioTemplateList"
    [eventTemplates]="eventTemplates$ | async"
    (refreshTemplates)="onRefreshTemplates()"></app-event-template-list>
</div>